import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  
  constructor(
    private rota: Router,
    public translateService: TranslateService, 
    public primeNGConfig: PrimeNGConfig,    
    ) {
      this.translateService.setDefaultLang('pt');
  }

  ngOnInit(): void {    
    window.scrollTo(0,0);
    this.translate("pt");
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
}
  
  exibindoNavBar() {
    return this.rota.url !== '/login';
  }
}
